/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TemplateAvailability {
    SELECTED_DEALS = 'SELECTED_DEALS',
    ALL_DEALS = 'ALL_DEALS',
}
